<app-multi-select-btn 
    [label]="'Task Groups'"
    [list]="groups"
    [selected]="selected"
    (onClosed)="closedEvent($event)">
</app-multi-select-btn>
